export default __webpack_public_path__ + "locales/ru/FillPDFDialog.json?hash=0a33eeba612b5a2f046eb069e2018e6b";